import React from 'react';
import AppLayout from '../../layout/app.layout';
import Reports from '../../components/common/reports/reports.component';

const ReportsMonlthlyView = () => {
  const pageTitle = 'Reports / Monthly';

  return (
    <AppLayout pageTitle={pageTitle}>
      <Reports />
    </AppLayout>
  );
};
export default ReportsMonlthlyView;
